<template>
    <div class="my-seasons w-100 h-100 overflow-auto">
        <div class="d-flex align-items-center justify-content-between px-4 py-3 my-seasons-topbar">
            <div class="my-seasons-title">{{ utils.get_season_label(window_mode, true) }}</div>
            <div class="d-flex align-items-center">
                <span class="my-seasons-user me-2" v-if="$store.state.online_user">{{ $store.state.online_user.username }}</span>
                <button type="button" class="btn btn-sm btn-outline-light" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>
            </div>
        </div>

        <div class="p-4">
            <div v-if="loading" class="my-seasons-empty">
                <span class="spinner-border spinner-border-sm me-2"></span>Cargando...
            </div>
            <div v-else-if="seasons.length == 0" class="my-seasons-empty">
                No hay {{ utils.get_season_label(window_mode, true).toLowerCase() }} disponibles todavía.
            </div>

            <div class="season-card" v-for="season in seasons" :key="season.id" @click="go_to_stages(season)">
                <div class="season-card-body">
                    <div class="season-card-name">{{ season.name }}</div>
                    <div class="season-card-dates" v-if="season.start_date || season.end_date">{{ format_date(season.start_date) }} &rarr; {{ format_date(season.end_date) }}</div>
                </div>
                <span :class="'season-status ' + season_status_class(season)">{{ season_status_label(season) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/../../shared/utils'
import api from '@/api'

export default {
    name: 'MySeasons',
    data(){
        return {
            utils: utils,
            window_mode: window.MODE,
            seasons: [],
            loading: true,
        };
    },
    async created(){
        try{
            const result = await api.seasons();
            this.seasons = result.seasons;
        }catch(ex){
            window.toast.error(ex.message || "No se han podido cargar las temporadas.");
        }finally{
            this.loading = false;
        }
    },
    methods: {
        format_date(value){
            if(!utils.is_valid_parameter(value))
                return '-';
            return new Date(value).toLocaleDateString();
        },
        season_status_class(season){
            const now = Date.now();
            if(season.start_date && now < new Date(season.start_date).getTime()) return "status-pending";
            if(season.end_date && now > new Date(season.end_date).getTime()) return "status-done";
            return "status-live";
        },
        season_status_label(season){
            const status = this.season_status_class(season);
            if(status == "status-pending") return "Próxima";
            if(status == "status-done") return "Finalizada";
            return "Abierta";
        },
        go_to_stages(season){
            this.$router.push({name: "MyStages", params: {season_id: season.id}});
        },
        logout(){
            utils.reset_online_client();
        }
    }
}
</script>

<style scoped>
    .my-seasons{
        background-color: var(--vc-paper-100);
    }

    .my-seasons-topbar{
        background-color: var(--vc-ink-900);
    }

    .my-seasons-user{
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.7);
    }

    .my-seasons-title{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        color: var(--vc-paper-50);
    }

    .my-seasons-empty{
        color: var(--vc-text-600);
        text-align: center;
        padding: 40px 0;
    }

    .season-card{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        background-color: var(--vc-paper-50);
        border: 1px solid var(--vc-line);
        border-radius: 10px;
        padding: 18px 20px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    .season-card:hover{
        border-color: var(--vc-accent-500);
    }

    .season-card-name{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.05rem;
    }

    .season-card-dates{
        font-size: 0.8rem;
        color: var(--vc-text-600);
        margin-top: 2px;
    }

    .season-status{
        display: inline-flex;
        align-items: center;
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.68rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        padding: 0.3em 0.8em;
        border-radius: 999px;
        white-space: nowrap;
        flex-shrink: 0;
    }
    .season-status.status-live{
        background-color: var(--vc-accent-100);
        color: var(--vc-accent-600);
    }
    .season-status.status-pending,
    .season-status.status-done{
        background-color: var(--vc-paper-200);
        color: var(--vc-text-600);
    }
</style>
